import { render, staticRenderFns } from "./zxks_ksxx.vue?vue&type=template&id=af1d9c32&scoped=true&"
import script from "./zxks_ksxx.vue?vue&type=script&lang=js&"
export * from "./zxks_ksxx.vue?vue&type=script&lang=js&"
import style0 from "./zxks_ksxx.vue?vue&type=style&index=0&id=af1d9c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d9c32",
  null
  
)

export default component.exports